import React from 'react'
import styled from 'styled-components'

const BoxContainerStyled = styled.div`
  border-radius: 0.875rem;
  border: 1px solid ${(props) => props.theme.palette.grey.grey300};
  padding: 1.5rem 1rem;
  margin-bottom: 2rem;
`

const BoxContainer = ({ children }: { children: React.ReactNode }) => {
  return <BoxContainerStyled>{children}</BoxContainerStyled>
}

export default React.memo(BoxContainer)
